/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { eDependencies } from './dependenciesE.generated.js';
import { createUppercaseE } from '../../factoriesAny.js';
export var EDependencies = {
  eDependencies,
  createUppercaseE
};